import * as React from "react";
import { FunctionComponent } from "react";

import Control from "./Control";

import "./LabelledControl.scss";

interface LabelledControlProps {
    label: string;
}

const LabelledControl: FunctionComponent<LabelledControlProps> = props => {
    return (
        <Control>
            <label className="mi-react-control-label">
                <span>{props.label}</span>
                {props.children}
            </label>
        </Control>
    );
};

export default LabelledControl;
